export const classes = {
  rows: 'flex flex-col',
  row: 'place-start gap-3 py-2',
  rank: 'w-[15px] shrink-0 text-right text-taupe-1 text-xs font-bold',
  name: 'w-[120px] shrink-0 text-taupe-3 text-[13px] font-semibold',
  bar: 'flex-1',
  value: 'w-[64px] shrink-0 text-right text-taupe-3 text-[13px] font-bold',
  valueSkeleton: 'flex justify-end',
  empty: 'text-taupe-1 text-sm py-6 text-center',
};
